import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import Login from "./pages/Login";
import Home from "./pages/home/Home";
import MauinLayout from "./components/navbar/NavBar";

const router = createBrowserRouter([
  //   { path: "/login", element: <Login /> },
  {
    element: <PublicRoute />,
    children: [{ path: "/login", element: <Login /> }],
  },
  {
    element: <MauinLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ path: "/", element: <Home /> }],
      },
    ],
  },
]);

export default router;
